import React from 'react';

interface ButtonProps {
  variant?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  style?: React.CSSProperties;
  icon?: React.ReactNode;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const Button: React.FC<ButtonProps> = ({
  variant = '',
  size = 'md',
  className = '',
  style,
  icon,
  children,
  onClick
}) => {
  const isMobile = window.innerWidth <= 576; // Adjust breakpoint as needed
  const buttonStyles = {
    backgroundColor: variant === 'primary' ? '#6750B8' : '#fff',
    borderColor: variant === 'primary' ? '#6750B8' : '#F5F5F5',
    color: variant === 'primary' ? 'white' : '#181D27',
  padding:
    window.innerWidth >= 768 && window.innerWidth <= 1440
      ? '12px 24px'
      : isMobile
      ?'8px 12px'
      : size === 'lg'
      ? '16px 32px'
      :'12px 24px',
    letterSpacing: '0.1px',
    fontWeight: '700',
    fontSize: isMobile ? '14px' : '16px',
    lineHeight: '22px',
    borderRadius: '25px',
    ...style,
  };

  return (
    <button
      className={`${className}`}
      style={buttonStyles}
      onClick={onClick}
    >

        {icon && <span>{icon}</span>}
        {children}
    </button>
  );
};

export default Button;
